"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [{
  label: 'Basic',
  id: 'basic',
  groups: [{
    symbols: [{
      latex: '\\frac',
      icon: '\\frac{&#x25FB;}{&#x25FB;}',
      title: 'fraction'
    }, {
      latex: '\\sqrt',
      icon: '\\sqrt{&#x25FB;}',
      title: 'square root'
    }, {
      latex: '\\nthroot',
      icon: '\\sqrt[&#x25FB;]{&#x25FB;}',
      title: 'nth root'
    }, {
      latex: '\\supscript',
      icon: 'x^{&#x25FB;}_{\\ }',
      title: 'superscript'
    }, {
      latex: '\\subscript',
      icon: 'x^{\\ }_{&#x25FB;}',
      title: 'subscript'
    }, {
      latex: '\\cdot',
      icon: '\\cdot',
      title: 'cdot'
    }, {
      latex: '\\div',
      icon: '\\div',
      title: 'divide'
    }, {
      latex: '\\pm',
      icon: '\\pm',
      title: 'pm'
    }]
  }, {
    symbols: [{
      latex: '\\pi',
      icon: '\\pi',
      title: 'pi'
    }, {
      latex: '\\le',
      icon: '\\le',
      title: 'less than or equal'
    }, {
      latex: '\\ge',
      icon: '\\ge',
      title: 'greater than or equal'
    }, {
      latex: '\\Leftrightarrow',
      icon: '\\Leftrightarrow',
      title: 'Left right arrow'
    }, {
      latex: '\\Longleftarrow',
      icon: '\\Longleftarrow',
      title: 'Left arrow'
    }, {
      latex: '\\Longrightarrow',
      icon: '\\Longrightarrow',
      title: 'Light arrow'
    }]
  }]
}, {
  label: 'Advanced',
  id: 'advanced',
  groups: [{
    symbols: [{
      latex: '\\int',
      icon: '\\int',
      title: 'integral'
    }, {
      latex: '\\oint',
      icon: '\\oint',
      title: 'contour integral'
    }, {
      latex: '\\sum',
      icon: '\\sum_{\\ }^{\\ }',
      title: 'sum'
    }, {
      latex: '\\prod',
      icon: '\\prod_{\\ }^{\\ }',
      title: 'prod'
    }, {
      latex: '\\prime',
      icon: '\\prime',
      title: 'prime'
    }, {
      latex: '\\vec',
      icon: '\\vec{&#x25FB;}',
      title: 'vector'
    }]
  }, {
    symbols: [{
      latex: '\\times',
      icon: '\\times',
      title: 'times'
    }, {
      latex: '\\ast',
      icon: '\\ast',
      title: 'ast'
    }, {
      latex: '\\infinity',
      icon: '\\infinity',
      title: 'infinity'
    }, {
      latex: '\\degree',
      icon: '\\degree',
      title: 'degrees'
    }]
  }, {
    symbols: [{
      latex: '\\alpha',
      icon: '\\alpha',
      title: 'alpha'
    }, {
      latex: '\\beta',
      icon: '\\beta',
      title: 'beta'
    }, {
      latex: '\\gamma',
      icon: '\\gamma',
      title: 'gamma'
    }, {
      latex: '\\delta',
      icon: '\\delta',
      title: 'delta'
    }, {
      latex: '\\epsilon',
      icon: '\\epsilon',
      title: 'epsilon'
    }, {
      latex: '\\zeta',
      icon: '\\zeta',
      title: 'zeta'
    }, {
      latex: '\\theta',
      icon: '\\theta',
      title: 'theta'
    }, {
      latex: '\\iota',
      icon: '\\iota',
      title: 'iota'
    }, {
      latex: '\\kappa',
      icon: '\\kappa',
      title: 'kappa'
    }, {
      latex: '\\lambda',
      icon: '\\lambda',
      title: 'lambda'
    }, {
      latex: '\\mu',
      icon: '\\mu',
      title: 'mu'
    }, {
      latex: '\\tau',
      icon: '\\tau',
      title: 'tau'
    }, {
      latex: '\\omega',
      icon: '\\omega',
      title: 'omega'
    }]
  }, {
    symbols: [{
      latex: '\\wedge',
      icon: '\\wedge',
      title: 'wedge'
    }, {
      latex: '\\vee',
      icon: '\\vee',
      title: 'vee'
    }, {
      latex: '\\cup',
      icon: '\\cup',
      title: 'cup'
    }, {
      latex: '\\cap',
      icon: '\\cap',
      title: 'cap'
    }, {
      latex: '\\approx',
      icon: '\\approx',
      title: 'approx'
    }, {
      latex: '\\subset',
      icon: '\\subset',
      title: 'subset'
    }, {
      latex: '\\supset',
      icon: '\\supset',
      title: 'supset'
    }, {
      latex: '\\subseteq',
      icon: '\\subseteq',
      title: 'subseteq'
    }, {
      latex: '\\supseteq',
      icon: '\\supseteq',
      title: 'supseteq'
    }, {
      latex: '\\varnothing',
      icon: '\\varnothing',
      title: 'varnothing'
    }, {
      latex: '\\forall',
      icon: '\\forall',
      title: 'forall'
    }, {
      latex: '\\in',
      icon: '\\in',
      title: 'in'
    }, {
      latex: '\\ni',
      icon: '\\ni',
      title: 'ni'
    }, {
      latex: '\\notin',
      icon: '\\notin',
      title: 'notin'
    }, {
      latex: '\\notni',
      icon: '\\notni',
      title: 'notni'
    }]
  }]
}];
var _default2 = _default;
exports.default = _default2;
module.exports = exports["default"];
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, "default", "/opt/TeamCity/buildAgent2/work/63f390c34456f15a/src/menuConfigs/default-menu.js");
}();

;